var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScratcher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 8,
    x2: 56,
    y1: 8,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "post",
    x1: 28,
    x2: 38,
    y1: 14,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6A66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92400E"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7C3AED",
    d: "M17 49h30l5 7H12l5-7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#post)",
    d: "M27 15h11v37H27z",
    rx: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FDE68A",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M28 21h9M28 27h9M28 33h9M28 39h9M28 45h9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A855F7",
    d: "M22 10h22v11H22z",
    rx: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F97316",
    d: "M45 23c5 0 9 4 9 9s-4 9-9 9-9-4-9-9 4-9 9-9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDBA74",
    d: "M41 32c0-2 2-4 4-4s4 2 4 4-2 4-4 4-4-2-4-4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScratcher);
export default __webpack_public_path__ + "static/media/scratcher.240d18dbde103aa4d748ad5070ad766d.svg";
export { ForwardRef as ReactComponent };